
import { Component, Mixins, Prop, Watch, Ref } from "vue-property-decorator";
import PageSection from "@/components/Common/PageSection.vue";
import { Service } from "../../models";
import VThrottlerInput from "@/components/Common/VThrottlerInput.vue";
import ServiceAdminMixin, {
  ServiceAdminTags,
} from "@/mixins/http/admin/ServiceAdminMixin";
import { safeAsync } from "@/utils/AsyncUtil";
import { RegisterHttp } from "@/utils/Decorators";
import { currentUserStore } from "@/store/typed";
import VPaginator from "@/components/Common/VPaginator.vue";
import RequestData from "@/store/types/RequestData";
import EmptyView from "@/components/Common/EmptyView.vue";
import ServiceModal from "@/components/Service/Modal.vue";
@Component({
  components: {
    PageSection,
    EmptyView,
    VPaginator,
    ServiceModal,
    VThrottlerInput,
  },
})
export default class ServiceList extends Mixins(ServiceAdminMixin) {
  @RegisterHttp(ServiceAdminTags.ServiceIndex)
  readonly indexRequest!: RequestData;

  @Prop() readonly realmId!: string;

  @Ref() readonly serviceModal!: ServiceModal;

  private items: Service[] = [];

  private error = false;

  private term: string | null = null;

  private page = 0;

  get columns() {
    return [
      { name: "name", label: "Nome" },
      { name: "dailyCost", label: "Costo giornaliero" },
      { name: "realm", label: "Lotto" },
      { name: "actions", label: "" },
    ];
  }

  get isMobile() {
    return this.$mq === "md" || this.$mq === "sm" || this.$mq === "xs";
  }

  get currentUser() {
    return currentUserStore.currentUser;
  }

  onCreated() {
    this.onPageChanged(1);
  }

  onUpdated(service: Service) {
    const index = this.items.findIndex((o: Service) => o.id === service.id);
    this.$set(this.items, index, service);
  }

  onDestroyed(id: string) {
    this.items = this.items.filter((o: Service) => o.id !== id);
  }

  onPageChanged(page: number) {
    this.page = page;
    this.load();
  }

  @Watch("term")
  onTermChanged(term: string) {
    this.$nextTick(() => {
      this.load();
    });
  }

  mounted() {
    this.load();
  }

  get loading() {
    return this.indexRequest?.loading;
  }

  get meta() {
    return this.indexRequest?.meta;
  }

  get filter() {
    const data: any = {
      page: { number: this.page },
      filter: { term: this.term },
    };

    if (this.realmId) {
      data.filter.realm = this.realmId;
    }

    return data;
  }

  get defaultService() {
    const instance = Service.empty();
    instance.realmId = this.realmId;
    return instance;
  }

  openCreateModal() {
    (this.serviceModal as any).add(this.defaultService);
  }

  openEditModal(service: Service) {
    (this.serviceModal as any).edit(service);
  }

  goToDetail(service: Service) {
    this.$router.push({
      name: "services_show",
      params: { serviceId: service.id },
    });
  }

  async load() {
    const [data, errors] = await safeAsync(
      this.getServices(this.filter.page, this.filter.filter)
    );

    if (!errors) {
      this.items = data;
    } else {
      this.error = true;
    }
  }
}
